'use client'

import { Select } from '@/components/ui/select'
import { useTranslations } from 'next-intl'
import { usePathname, useSearchParams } from 'next/navigation'
import { COLLECTION_SORT_LABELS, ECollectionSort } from '../../constants'
import { useCollectionStore } from '../../store/collection-store'
import { updateUrl } from '../../utils/filter-utils'

type Props = {
  title?: string
}

export const FilterBarShort: React.FC<Props> = ({ title }) => {
  const productCount = useCollectionStore((s) => s.productCount)
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const setFilter = useCollectionStore((s) => s.setFilter)
  const t = useTranslations('collection_page')

  const handleFilterChange = (value: string) => {
    const params = new URLSearchParams(searchParams)
    params.set('sort', value)
    updateUrl(`${pathname}?${params.toString()}`, { scroll: false })
    setFilter({ sort: value })
  }

  const sort = searchParams.get('sort')

  // Sử dụng sort options từ constants
  const sortOptions = Object.entries(COLLECTION_SORT_LABELS).map(
    ([key, label]) => ({
      value: key,
      label: t(`sort_label.${label}`),
    })
  )

  return (
    <div className='flex items-center justify-between bg-light px-5 pb-4 pt-3.5 max-lg:shadow-[0_4px_12px_0_rgba(0,0,0,0.08)] lg:p-0'>
      {title ? (
        <h1 className='font-criteria text-[32px] font-medium uppercase leading-13 text-neutral-900'>
          {title}
        </h1>
      ) : (
        <p className='font-sans text-sm leading-4.5 text-neutral-500'>
          {t('filter_bar.results', { count: productCount || 0 })}
        </p>
      )}

      <div className='flex items-center gap-2'>
        <span className='whitespace-nowrap font-sans text-sm font-medium uppercase leading-4.5 text-neutral-900 opacity-40 max-lg:hidden'>
          {t('filter_bar.sort_label')}
        </span>
        <Select
          options={sortOptions}
          placeholder={t('filter_bar.sort_placeholder')}
          className={{
            trigger:
              'border-neutral-100 bg-neutral-100 data-[placeholder]:text-neutral-600',
          }}
          onValueChange={handleFilterChange}
          defaultValue={sort || ECollectionSort.NEW}
        />
      </div>
    </div>
  )
}
